import React from "react";
import { Skeleton, Table } from "antd";
import { useSelector } from "react-redux";

const ACTION_CODE_FULL_FORMS = {
    ptp: "Promise To Pay",
    bptp: "Broken Promise To Pay",
    rtp: "Refusal To Pay",
    wna: "Wrong Number Attached",
};

const getActionCodeLabel = (key) => {
    const cleanKey = String(key || "").toLowerCase().trim();
    let fullForm = ACTION_CODE_FULL_FORMS[cleanKey];
    
    if (!fullForm) {
        fullForm = cleanKey.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
    }

    if (cleanKey.replace(/_/g, " ") === fullForm.toLowerCase()) {
        return fullForm;
    }
    
    return `${key.toUpperCase()} - ${fullForm}`;
};

const ActionCodeTable = ({ handleRowClick = () => { } }) => {
    const { tele_action_codes, tele_action_codes_loading } = useSelector(state => state.telecallerDashboard);

    // Convert object to array for AntD Table
    const tableData = tele_action_codes && Object.entries(tele_action_codes)?.map(([key, value]) => ({
        key,
        action_code: getActionCodeLabel(key),
        todays_count: value.today_count,
        yesterdays_count: value.yesterday_count,
        this_month_count: value.this_month_count,
        total_count: value.total_count,
        filter_key:value?.action_code_key
    }));

    const columns = [
        {
            title: "Action Code",
            dataIndex: "action_code",
            key: "action_code",
            align: "center",
            render: (text) => tele_action_codes_loading ? <Skeleton.Input size="small" active /> : text
        },
        {
            title: "Today's Count",
            dataIndex: "todays_count",
            key: "todays_count",
            align: "center",
            render: (text) => tele_action_codes_loading ? <Skeleton.Input size="small" active /> : text

        },
        {
            title: "Yesterday's Count",
            dataIndex: "yesterdays_count",
            key: "yesterdays_count",
            align: "center",
            render: (text) => tele_action_codes_loading ? <Skeleton.Input size="small" active /> : text

        },
        {
            title: "This Month Count",
            dataIndex: "this_month_count",
            key: "this_month_count",
            align: "center",
            render: (text) => tele_action_codes_loading ? <Skeleton.Input size="small" active /> : text

        },
        {
            title: "Total Count",
            dataIndex: "total_count",
            key: "total_count",
            align: "center",
            render: (text) => tele_action_codes_loading ? <Skeleton.Input size="small" active /> : text

        },
    ];

    return (
        <div className="dsh-plain-table">
            <Table
                columns={columns}
                dataSource={tele_action_codes_loading ? Array(5).fill({}) : tableData}
                pagination={false}
                scroll={{ x: "max-content" }}
                style={{ width: '100%' }}
               rowClassName='clickable-row'
                onRow={(record, index) => {
                    return {
                        onClick: () => {
                          handleRowClick(record)
                        },
                    }
                }}

            />
        </div>
    );
};

export default ActionCodeTable;
